import "../assets/styles/components/splash.scss";
import Logo from "../assets/images/logo-completo-bianco.svg";

export default function Splash() {
  return (
    <div className="splash-container d-lg-none position-fixed top-0 left-0 d-flex align-items-center justify-content-center w-100 h-100">
      <img className="splash-container__logo" src={Logo} />
    </div>
  );
}
